import { useMutation } from "@tanstack/react-query";
import RvxTag from "components/RvxTag";
import { ScrollColumn } from "components/BaseTableV3/ScrollColumn";
import { useApplyTagDialog } from "providers/ApplyTagDialogProvider";
import TagService from "services/Tag";
import { List } from "semantic-ui-react";

function TagList({
  tags,
  modelType,
  modelId,
  onUpdate,
  tableCell = false,
  readOnly,
}) {
  const openApplyTagDialog = useApplyTagDialog();

  const applyTagMutation = useMutation({
    mutationFn: ({ tag, metadata }) =>
      TagService.addTag(tag, modelType, [modelId], metadata),
    onSuccess: () => onUpdate?.(),
  });

  const isTagDisabled = tag => readOnly || tag.disableClick || !tag.enabled;
  const openApplyDialog = tag =>
    openApplyTagDialog(
      tag,
      metadata => applyTagMutation.mutateAsync({ tag, metadata }),
      modelType
    );

  const sortedTags = [...(tags ?? [])].sort((firstTag, secondTag) =>
    firstTag.name.localeCompare(secondTag.name)
  );

  return (
    <>
      {tableCell ? (
        // Tag pills already read as separate units, so the scrolling row skips
        // the commas it draws between plain text values.
        <ScrollColumn separated={false}>
          {sortedTags.map(tag => (
            <li key={`tag-${tag.id}`}>
              <RvxTag
                tag={tag}
                onClick={openApplyDialog}
                tableCell={tableCell}
                styleProps={{
                  pointerEvents: isTagDisabled(tag) ? "none" : "auto",
                  opacity: isTagDisabled(tag) ? 0.5 : 1,
                }}
              />
            </li>
          ))}
        </ScrollColumn>
      ) : (
        <List horizontal>
          {sortedTags.map(tag => (
            <RvxTag
              key={`tag-${tag.id}`}
              tag={tag}
              onClick={openApplyDialog}
              tableCell={tableCell}
              styleProps={{
                pointerEvents: isTagDisabled(tag) ? "none" : "auto",
                opacity: isTagDisabled(tag) ? 0.5 : 1,
              }}
            />
          ))}
        </List>
      )}
    </>
  );
}

export default TagList;
